import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './MultiProperty.styles';

export interface MultiPropertyIconProps extends WithStyles<typeof styles> {
  fontSize?: number;
}

const MultiPropertyIconComponent: FC<MultiPropertyIconProps> = ({ classes, fontSize }) => {
  return (
    <SvgIcon
      classes={{ root: classes.root }}
      fill="none"
      height="14"
      style={fontSize ? { fontSize: fontSize } : undefined}
      viewBox="0 0 16 14"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 6.33333H3.06667C2.6933 6.33333 2.50661 6.33333 2.36401 6.406C2.23856 6.46991 2.13658 6.5719 2.07266 6.69734C2 6.83995 2 7.02663 2 7.4V13M11 6.33333H12.9333C13.3067 6.33333 13.4934 6.33333 13.636 6.406C13.7614 6.46991 13.8634 6.5719 13.9273 6.69734C14 6.83995 14 7.02663 14 7.4V13M11 13V3.13333C11 2.3866 11 2.01323 10.8547 1.72801C10.7268 1.47713 10.5229 1.27316 10.272 1.14532C9.98677 1 9.6134 1 8.86667 1H7.13333C6.3866 1 6.01323 1 5.72801 1.14532C5.47713 1.27316 5.27316 1.47713 5.14532 1.72801C5 2.01323 5 2.3866 5 3.13333V13M14.6667 13H1.33333M7.33333 3.66667H8.66667M7.33333 6.33333H8.66667M7.33333 9H8.66667"
        stroke="#535F73"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
};

export const MultiPropertyIcon = withStyles(styles)(MultiPropertyIconComponent);
